module.exports = __webpack_public_path__ + "0f8ffe7d2748c670fa1a5fe74fc0f4d7.png";